

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { NavigationLink } from 'types/header';

@Component
export default class NavigationLinkMobile extends Vue {
	@Prop()
	private link!: NavigationLink;
}
